import variant from '@jitl/quickjs-singlefile-browser-release-asyncify';
import { newQuickJSAsyncWASMModuleFromVariant, QuickJSAsyncRuntime, QuickJSAsyncWASMModule } from 'quickjs-emscripten-core';

export class JavascriptRuntimeManager {
  private quickJs?: QuickJSAsyncWASMModule;
  private runtime?: QuickJSAsyncRuntime;
  private initialized = false;

  async initialize(): Promise<void> {
    if (this.initialized && this.runtime) {
      return; // Already initialized
    }

    this.quickJs = await newQuickJSAsyncWASMModuleFromVariant(variant);
    this.runtime = this.quickJs.newRuntime();
    this.runtime.setMemoryLimit(5e7);
    this.runtime.setMaxStackSize(5e6);
    this.runtime.setInterruptHandler(() => false);
    this.initialized = true;
  }

  async getHealthyRuntime(): Promise<QuickJSAsyncRuntime> {
    // Auto-initialize if needed
    if (!this.initialized || !this.runtime) {
      await this.initialize();
    }

    // Health check
    if (!this.isRuntimeHealthy()) {
      await this.recreateRuntime();
    }

    return this.runtime!;
  }

  private isRuntimeHealthy(): boolean {
    if (!this.runtime) return false;

    try {
      // Simple health check - try to create and dispose a context
      const testContext = this.runtime.newContext();
      testContext.dispose();
      return true;
    } catch {
      return false;
    }
  }

  private async recreateRuntime(): Promise<void> {
    this.dispose();
    await this.initialize();
  }

  dispose(): void {
    if (this.runtime) {
      this.runtime.dispose();
      this.runtime = undefined;
    }
    this.initialized = false;
  }
}
